import { gql } from '@apollo/client';

export const FRAGMENT_GENERAL_ANNOUNCEMENT = gql`
  fragment GeneralAnnouncementFields on GeneralAnnouncement {
    urlCode
    title
    url
  }
`;
